// TODO: will be use for common functions
import React from "react";
import { components } from "react-select";

const FilterCountBadge = ({ items }) => {
  const style = {
    background: "#e6e6e6",
    borderRadius: "2px",
    fontFamily: "sans-serif",
    fontSize: "13px",
    padding: "3px 6px",
    order: 99,
    whiteSpace: "nowrap",
  };

  const title = items.join(", ");
  const { length } = items;
  const label = `+ ${length}`;

  return (
    <div style={style} title={title}>
      {label}
    </div>
  );
};

// To show state count as badge
const ShowFilterCount = ({ index, getValue, ...props }) => {
  const maxToShow = 2;
  const overflow = getValue()
    .slice(maxToShow)
    .map((x) => x.label);

  return index < maxToShow ? (
    <components.MultiValue {...props} />
  ) : index === maxToShow ? (
    <FilterCountBadge items={overflow} />
  ) : null;
};

export { ShowFilterCount, FilterCountBadge };
